import { render, staticRenderFns } from "./TopChart.vue?vue&type=template&id=f7babca2&scoped=true&"
import script from "./TopChart.vue?vue&type=script&lang=js&"
export * from "./TopChart.vue?vue&type=script&lang=js&"
import style0 from "./TopChart.vue?vue&type=style&index=0&id=f7babca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7babca2",
  null
  
)

export default component.exports